import type { CampaignSourceType } from '@barel/api-client/react';

export type CampaignSearchSourceType = Exclude<CampaignSourceType, 'csv'>;

const LINKEDIN_ORIGIN = 'https://www.linkedin.com';
const SEARCH_PATHS: Record<CampaignSearchSourceType, string> = {
  linkedin: '/search/results/people',
  salesnav: '/sales/search/people',
};

function normalizePath(pathname: string): string {
  const trimmed = pathname.replace(/\/+$/, '');
  return trimmed || '/';
}

/**
 * Validate the exact LinkedIn people-search surface used by the extension.
 * The normalized value preserves the user's filters while removing fragments,
 * which are never sent to the server.
 */
export function normalizeCampaignSearchUrl(
  rawUrl: string,
  expectedSource: CampaignSearchSourceType,
): string | null {
  let url: URL;
  try {
    url = new URL(rawUrl.trim());
  } catch {
    return null;
  }

  if (
    url.origin !== LINKEDIN_ORIGIN ||
    url.protocol !== 'https:' ||
    url.username ||
    url.password ||
    url.port ||
    normalizePath(url.pathname) !== SEARCH_PATHS[expectedSource]
  ) {
    return null;
  }

  url.pathname = SEARCH_PATHS[expectedSource];
  url.hash = '';
  return url.toString();
}

export function isValidCampaignSearchUrl(
  rawUrl: string,
  expectedSource: CampaignSearchSourceType,
): boolean {
  return normalizeCampaignSearchUrl(rawUrl, expectedSource) !== null;
}
